import { FC } from 'react'
import Layout from '@/Layouts/Default'
import { Container } from '@/components/UI/Container'
import { DailySalesSummaryPage } from './DailySalesSummaryPage'

export const DailySalesSummary: FC = () => {
  return (
    <Layout>
      <Container maxWidth='7xl'>
        <div className='py-6'>
          <DailySalesSummaryPage />
        </div>
      </Container>
    </Layout>
  )
}